import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { DealsModal } from 'app/views/pages/deals-management/deals/deals-modal'
import PrimaryInput from 'app/views/components/buttons/PrimaryInput'
import { loadDealFormLists } from 'app/state/utils/form-lists'

function CreateDealButton() {
  const dispatch = useDispatch()
  const [open, setOpen] = useState(false)
  const [loading, setLoading] = useState(false)

  // The form builds its dropdowns once, from the store, so its lists are in
  // before it mounts: the modal shows a loader until they are.
  async function openForm() {
    setLoading(true)
    setOpen(true)
    try {
      await dispatch(loadDealFormLists() as any)
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <PrimaryInput onClick={() => openForm()} text="Create Deal" />
      <DealsModal open={open} setOpen={setOpen} loading={loading} />
    </>
  )
}

export default CreateDealButton
